import { FEATURE_FLAG_ID } from '../data-types/feature-flags/featureFlagsEnums';
import { FeatureFlagsData } from '../data-types/feature-flags/featureFlagsInterfaces';
import { userFeatureFlags } from '../socket-types/userScoketTypes';
import { setFeatureFlags } from '../state/actions/customizationActions';
import { sendCommand } from './commandsHandler';

export const checkFeatureFlags = async () => {
  try {
    const featureFlags = await sendCommand<FeatureFlagsData>(userFeatureFlags, {});

    const cashoutFeatureFlag = featureFlags.data.find(flag => flag.id === FEATURE_FLAG_ID.CASHOUT);
    const moodBarFeatureFlag = featureFlags.data.find(flag => flag.id === FEATURE_FLAG_ID.MOOD_BAR);
    const trendingBetsFeatureFlag = featureFlags.data.find(flag => flag.id === FEATURE_FLAG_ID.TRENDING_BETS);
    const forumFeedbackFeatureFlag = featureFlags.data.find(flag => flag.id === FEATURE_FLAG_ID.FEEDBACK_FORUM);
    const casinoNetAndTimerFlag = featureFlags.data.find(flag => flag.id === FEATURE_FLAG_ID.CASINO_NET_AND_TIMER);
    const displayBespokeRecommendedGamesFlag = featureFlags.data.find(flag => flag.id === FEATURE_FLAG_ID.BESPOKE_CASINO);
    const bespokeSportsMenu = featureFlags.data.find(flag => flag.id === FEATURE_FLAG_ID.BESPOKE_SPORTS_MENU);
    const bespokeCompetitions = featureFlags.data.find(flag => flag.id === FEATURE_FLAG_ID.BESPOKE_COMPETITIONS);
    const referAFriend = featureFlags.data.find(flag => flag.id === FEATURE_FLAG_ID.REFER_A_FRIEND);
    const promoCentre = featureFlags.data.find(flag => flag.id === FEATURE_FLAG_ID.PROMO_CENTRE);

    setFeatureFlags({
      cashout: (cashoutFeatureFlag && cashoutFeatureFlag.status) || false,
      moodBar: (moodBarFeatureFlag && moodBarFeatureFlag.status) || false,
      trendingBets: (trendingBetsFeatureFlag && trendingBetsFeatureFlag.status) || false,
      feedbackForum: (forumFeedbackFeatureFlag && forumFeedbackFeatureFlag.status) || false,
      casinoNetAndTimer: (casinoNetAndTimerFlag && casinoNetAndTimerFlag.status) || false,
      displayBespokeRecommendedGames: (displayBespokeRecommendedGamesFlag && displayBespokeRecommendedGamesFlag.status) || false,
      bespokeSportsMenu: (bespokeSportsMenu && bespokeSportsMenu.status) || false,
      bespokeCompetitions: (bespokeCompetitions && bespokeCompetitions.status) || false,
      referAFriend: (referAFriend && referAFriend.status) || false,
      promoCentre: (promoCentre && promoCentre.status) || false,
    });
  } catch (e) {
    setFeatureFlags({
      cashout: false,
      moodBar: false,
      trendingBets: false,
      feedbackForum: false,
      casinoNetAndTimer: false,
      displayBespokeRecommendedGames: false,
      bespokeSportsMenu: false,
      bespokeCompetitions: false,
      referAFriend: false,
      promoCentre: false,
    });
  }
};
